import { NAV_LINKS } from "../constants/data";
import { scrollTo } from "../utils/scroll";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      style={{
        background: "#0f172a",
        color: "white",
        padding: "56px 20px 24px",
      }}
    >
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1.5fr 1fr 1fr",
            gap: 40,
            marginBottom: 40,
          }}
        >
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                marginBottom: 16,
              }}
            >
              <div
                style={{
                  width: 42,
                  height: 42,
                  borderRadius: "50%",
                  background: "linear-gradient(135deg,#1d4ed8,#0d9488)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 700,
                  fontSize: 14,
                }}
              >
                GM
              </div>
              <div>
                <div style={{ fontWeight: 700, fontSize: 14 }}>
                  Dr. Gaurav B. Modi
                </div>
                <div style={{ color: "#0d9488", fontSize: 12 }}>
                  MD, DM (Nephrology)
                </div>
              </div>
            </div>
            <p style={{ color: "#94a3b8", fontSize: 13, lineHeight: 1.7 }}>
              Consultant Nephrologist & Kidney Transplant Physician. Serving
              Ahmedabad with compassionate, evidence-based kidney care since
              over a decade.
            </p>
          </div>

          <div>
            <div
              style={{
                fontWeight: 600,
                fontSize: 12,
                textTransform: "uppercase",
                letterSpacing: 2,
                color: "#94a3b8",
                marginBottom: 16,
              }}
            >
              Quick Links
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {NAV_LINKS.map((link) => (
                <button
                  key={link}
                  onClick={() => scrollTo(link.toLowerCase())}
                  style={{
                    background: "none",
                    border: "none",
                    textAlign: "left",
                    color: "#94a3b8",
                    fontSize: 13,
                    cursor: "pointer",
                    transition: "color 0.2s",
                    padding: 0,
                  }}
                  onMouseEnter={(e) => {
                    (e.currentTarget as HTMLButtonElement).style.color =
                      "#0d9488";
                  }}
                  onMouseLeave={(e) => {
                    (e.currentTarget as HTMLButtonElement).style.color =
                      "#94a3b8";
                  }}
                >
                  {link}
                </button>
              ))}
            </div>
          </div>

          <div>
            <div
              style={{
                fontWeight: 600,
                fontSize: 12,
                textTransform: "uppercase",
                letterSpacing: 2,
                color: "#94a3b8",
                marginBottom: 16,
              }}
            >
              Contact
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
                color: "#94a3b8",
                fontSize: 13,
                marginBottom: 20,
              }}
            >
              <span>📍 Shahibaug & Nikol, Ahmedabad</span>
              <span>📞 +91 91572 60376</span>
              <span>🕐 Mon – Sat (see clinic timings)</span>
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              {[
                { label: "FB", url: "https://www.facebook.com/share/1BycZS3A1v/" },
                { label: "IG", url: "https://www.instagram.com/gauravmodi912?igsh=MTFxMXN5dmt0OGsxNw==" },
                { label: "IN", url: "https://www.linkedin.com/in/prakashmodi11191/" }
              ].map((social, i) => (
                <a
                  key={i}
                  href={social.url}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.08)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 12,
                    fontWeight: 700,
                    cursor: "pointer",
                    transition: "background 0.2s",
                    color: "white",
                    textDecoration: "none",
                  }}
                  onMouseEnter={(e) => {
                    (e.currentTarget as HTMLAnchorElement).style.background = "#0d9488";
                  }}
                  onMouseLeave={(e) => {
                    (e.currentTarget as HTMLAnchorElement).style.background =
                      "rgba(255,255,255,0.08)";
                  }}
                >
                  {social.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div
          style={{
            borderTop: "1px solid rgba(255,255,255,0.08)",
            paddingTop: 24,
            textAlign: "center",
            color: "#64748b",
            fontSize: 12,
          }}
        >
          © {currentYear} Dr. Gaurav B. Modi · All rights reserved · Designed
          with ❤️ for kidney health
        </div>
      </div>
    </footer>
  );
}
